import styled, { css } from 'styled-components'

export const StyledIconWrapper = styled.span`
  ${props =>
    css`
      & > svg {
        fill: ${props.theme.colors.primary};
      }
    `}
`

export const StyledInfo = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #00112b;
  margin-top: 8px;
`

export const StyledChildrenWrapper = styled.span`
  margin-top: 10px;
`

export const StyledTimestampTemplate = styled.div`
  text-align: left;
`
export const StyledBold = styled.span`
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
`
